import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { InstitutionType } from '@app/models/institution';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { CountryService } from '@app/services/shared/country.service';
import { Country } from '@app/models/country';

import { SortService } from '@app/components/sorting/SortService';
import { ClaimsService } from '@app/services/claims/claims.service';
import { AuthService } from '@app/services/auth/auth.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { MenuItem, MessageService } from 'primeng/api';
import { AdminService } from '@app/services/admin/admin.service';
import { CSVDataService } from '@app/export/CSVDataService';
import moment from 'moment';
import { ActivatedRoute } from '@angular/router';

export interface Member {
  id: number;
  givenName: string;
  familyName: string;
  homeCity: string;
  institutionShortName: string;
  institutionName: string;
  checked: boolean;
}

interface EtikettMember {
  givenName: string;
  familyName: string;
  street: string;
  zipcode: string;
  city: string;
  id: number;
  institution: string;

}

@Component({
  selector: 'app-searchmember',
  templateUrl: './searchmember.component.html',
  styleUrls: ['./searchmember.component.css']
})

export class SearchmemberComponent implements OnInit, OnDestroy {
  @Input() mentor: boolean;
  @Output() changeMentor = new EventEmitter();
  @ViewChild('panel') panel;
  access;
  role;
  showInactive = false;
  name: string;
  onlynumbers = '^[0-9]*$';
  showMailView = false;
  searchmemberform;
  
  title = 'Sök medlem';
  members: Member[] = [];
  institutiontypeid: number;
  show = false;
  countries: Country[] = [];
  institutiontypes: InstitutionType[] = [];
  noHit = false;
  isExpanded = true;

  isSomekindofAdmin = false;
  isSysAdmin = false;
  isClerk = false;
  usualmember = false;

  etikettlist: EtikettMember[] = [];
  to: string[] = [];

  subscriptions: Subscription[] = [];
  mobiledevice = false;
  minmaxyear = { minYear: '1800', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  baseinfo;
  items: MenuItem[];
  emailaddresses;
  offices: any[] = [];
  id: string = "";
  // tslint:disable-next-line:max-line-length
  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private permissionsService: PermissionsService,
    private memberService: MemberService,
    private authService: AuthService,
    private claimsService: ClaimsService,
    private institutionService: InstitutionsService,
    private countryService: CountryService,
    private route: ActivatedRoute,
    private messageService: MessageService) {
    
      this.claimsService.claims$.subscribe(x => {
        if(x) {
          this.id = x.id;
        }
      })
    this.show = true;
   
  }

  getOffices() {
    this.adminService.GetOffices().subscribe(data => {
      this.offices = data;
    });
  }
  ngOnInit() {
    this.searchmemberform = this.fb.group({
      onlyActiveMembers: [true, ''],
      memberId: ['', Validators.pattern(this.onlynumbers)],
      memberIdFrom: ['', Validators.pattern(this.onlynumbers)],
      memberIdTo: ['', Validators.pattern(this.onlynumbers)],
      givenName: ['', ''],
      familyName: ['', ''],
      homeCity: ['', ''],
      homeCountry: ['', ''],
      birthDate: ['', ''],
      birthDateFrom: ['', ''],
      birthDateTo: ['', ''],
      institutionTypeId: [null, null],
      institutionNumber: ['', Validators.pattern(this.onlynumbers)],
      institutionName: ['', ''],
      institutionCity: ['', '']
    });
  
    this.route.queryParams.subscribe(qParams => {
      this.searchmemberform.patchValue({ institutionName: qParams.institutionName, institutionNumber: qParams.institutionNumber, institutionTypeId: qParams.institutionTypeId });
    });
    this.permissionsService.selectedrole.subscribe(r => {
      if (r) {
        this.role = r;
        this.setInitialValues(r.institution);
        this.getInstitutionTypes();
      }
    });

    this.subscriptions.push(this.permissionsService.selectedrole.subscribe(resp => {
      if (resp) {
        this.role = resp;
        this.searchMember();
      }
    }));

    this.permissionsService.setMemberAccess();

    this.permissionsService.access.subscribe(a => {
      if (a) {
        this.access = a;
      }
    });

    this.subscriptions.push(this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    }));

    this.subscriptions.push(this.claimsService.claims$.subscribe(data => {
      this.baseinfo = data;
    }));

    this.subscriptions.push(this.route.params.subscribe(params => {
      if (params['institutionNumber']) {
        this.searchMember();
      }
    }));

    this.isSomekindofAdmin = this.claimsService?.isSomekindofAdmin();
    this.isClerk = this.claimsService.isClerk();
    this.isSysAdmin = this.claimsService.isSysAdmin();
    this.usualmember = !this?.isSomekindofAdmin;
    this.getInstitutionTypes();
  // this.countries = this.countryService.getCountryList();
    
    if (this.mentor) {
      this.title = 'Sök fadder';
    }
    this.setItems();
  }

  setInitialValues(institution: any) {
    this.countryService.getCountries().subscribe(c => {
      this.countries = c;
    });

    if (!this.searchmemberform.get('institutionNumber').value) {
      this.searchmemberform.patchValue({ institutionNumber: institution.institutionNumber, institutionTypeId: institution.institutionTypeId });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  onSubmit() {
  }

  sendMail() {
    this.showMailView = true;
  }

  setItems() {
    this.items = [
      {
        label: 'Etiketter',
        icon: 'fa fa-id-card-o',
        command: () => this.createEtikettFile(),
        visible: !this.mobiledevice && this.etikettlist.length > 0 && this.role.permissions.includes('VIEW_POSTALS')
      }, {
        label: 'Epost',
        icon: 'fa fa-envelope',
        command: () => this.sendMail(),
        visible: !this.mobiledevice && this.etikettlist.length > 0 && this.role.permissions.includes('SEND_EMAIL')
      }, {
        label: 'Excel',
        icon: 'pi pi-file-excel',
        command: () => this.generateCSV(),
        visible: !this.mobiledevice && this.etikettlist.length > 0 && +this.id === 30127
      }];
  }

 generateCSV() {
  let idlista: any[] = [];
    if (this.etikettlist?.length > 0) {
      this.etikettlist.forEach(x => {
        idlista.push(x.id);
      });
    }

    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {
        let memberlista: any[] = [];
        x.forEach(i => {
          const data = {
            id: i.memberId,
            givenName: i.givenName + ' ' + i.familyName,
            email1: i.email,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry,
            institutionShortName: i.primaryInstitution[0].shortName,
            institutionName: i.primaryInstitution[0].name
          };
          memberlista.push(data);
        });
        const firstrow = 'Id;Namn;Epost;Gatuadress;Postnummer;Ort;Land;Institution;Institutionsnamn;';
        const filnamn = 'OF_Epostlista';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
 }

  add(selectedmember, element) {
    if (element.checked) {
      if (!this.checkMember(selectedmember.id)) {
        const etikettmember = {
          givenName: selectedmember.givenName,
          familyName: selectedmember.familyName,
          street: selectedmember.street,
          zipcode: selectedmember.zipCode,
          city: selectedmember.city,
          id: selectedmember.id,
          email1: selectedmember.email,
          institution: selectedmember.id + ' ' + selectedmember.institutionShortName + ' ' + selectedmember.institutionName,
          checked: true
        };
        this.etikettlist.push(etikettmember);
        const idx = this.members.findIndex(m => m.id === selectedmember.id);
        this.members[idx].checked = true;
      }

    } else {
      this.removeFromArray(selectedmember.id);
      const idx = this.members.findIndex(m => m.id === selectedmember.id);
      this.members[idx].checked = false;
    }
    this.setItems();
  }

  checkMember(memberid: number) {
    return this.etikettlist.find(item => item.id === memberid);
  }

  createEtikettFile() {
    let idlista: any[] = [];
    if (this.etikettlist?.length > 0) {
      this.etikettlist.forEach(x => {
        idlista.push(x.id);
      });
    }

    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {
        let memberlista: any[] = [];
        x.forEach(i => {
          const data = {
            givenName: i.givenName + ' ' + i.familyName,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          memberlista.push(data);
        });
        const firstrow = 'Namn;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_medlemmar';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
  }

 

  removeFromArray(id: number) {
    const idx = this.etikettlist.findIndex(item => item.id === id);
    this.etikettlist.splice(idx, 1);
  }

  searchMember() {
    this.etikettlist = [];
    if (this.searchmemberform.get('birthDate').value !== '') {
      this.searchmemberform.patchValue({
        birthDate: moment(this.searchmemberform.get('birthDate').value).add(3, 'h').format('YYYY-MM-DD')
      });
    }
    this.subscriptions.push(this.memberService.searchMember(this.searchmemberform.value as any).subscribe(data => {
      this.members = data.item2;
      if (data.item1 == '') {
        this.members.forEach(m => {
          m['checked'] = false;
        });

        this.members.length === 0 ? this.noHit = true : this.noHit = false;
        if (this.members.length > 0) {
          const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi');
          isMobileDevice ? this.isExpanded = false : this.isExpanded = true;
          isMobileDevice ? this.panel.close() : null;
        }
      } else {
       // this.messageService.add({ severity: 'warn', summary: 'Information', detail: data.item1 });
      }
    }));
  }

  getInstitutionTypes() {
    this.subscriptions.push(this.institutionService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
      if (this.role?.userPermissionLevel === 'ME') {
        const removelist = ['AV', 'AVGBREV', 'UT', 'EL', 'ELA', 'K', 'RLK', 'RR', 'SOFT'];
        this.institutiontypes = this.institutiontypes.filter(x => {
          return removelist.indexOf(x.prefix) === -1;
        });
      }
    }));
  }

  clear() {
    const activemembers = this.searchmemberform.get('onlyActiveMembers').value;
    this.searchmemberform = this.fb.group({
      onlyActiveMembers: [true, ''],
      memberId: ['', Validators.pattern(this.onlynumbers)],
      memberIdFrom: ['', Validators.pattern(this.onlynumbers)],
      memberIdTo: ['', Validators.pattern(this.onlynumbers)],
      givenName: [''],
      familyName: [''],
      homeCity: [''],
      homeCountry: [''],
      birthDate: [''],
      birthDateFrom: [''],
      birthDateTo: [''],
      institutionTypeId: [''],
      institutionNumber: ['', Validators.pattern(this.onlynumbers)],
      institutionName: [''],
      institutionCity: ['']
    });
    this.searchmemberform.get('onlyActiveMembers').setValue(activemembers);
    this.members = [];
    this.noHit = false;
    const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi');
    isMobileDevice ? this.panel.open() : null;
  }

  sortData(sort: Sort) {
    const data = this.members.slice();
    if (!sort.active || sort.direction === '') {
      this.members = data;
      return;
    }

    this.members = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'givenName': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyName': return this.compare(a.familyName, b.familyName, isAsc);
        case 'homeCity': return this.compare(a.homeCity, b.homeCity, isAsc);
        case 'institutionShortName': return SortService.cmpStringsWithNumbers(a.institutionShortName, b.institutionShortName, isAsc);
        case 'institutionName': return this.compare(a.institutionName, b.institutionName, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  selectMember(m) {
    this.changeMentor.emit(m);
  }

  cancel() {
    this.selectMember('cancelselectmember');
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.selectMember('nomemberchoosen');
  }

  sortTest() {
  }

  closeEmail(evt: any) {
    this.showMailView = false;
    this.setItems();
    this.etikettlist = [];
    this.members.forEach(m => m.checked = false);
  }

  checkuncheckAll(element) {
    let value = false;
    element.checked ? value = true : value = false;
    for (const m of this.members) {
      m.checked = value;
      this.add(m, element);
    }
  }
}
